import {
  bonitickAuthenticatedPostFetchWithResult,
} from '../../../src/utils/BonitickAuthenticatedFetch';

import {
  authenticatedGetFetchWithoutLoginRedirection,
} from '../../../src/utils/AuthenticatedFetch';

function parseSite(input) {
  let sites = [];

  for (const site of input)
    sites.push({ id: site.infoSup.publicId.site, name: site.name, idOperator: site.infoSup.publicId.operator, idCountry: site.infoSup.country, server: site.id });

  return sites;
}


export async function getDiscountLookup() {
  if (localStorage.getItem("discountLookup") !== null) {
    return JSON.parse(localStorage.getItem("discountLookup"));
  }
  else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("discountLookup") == null) {
        bonitickAuthenticatedPostFetchWithResult('/bonification', {}, (response, data) => {
          if (response > 300) { res([]); return; }
          if (!data.discounts) data.discounts = [];
          localStorage.setItem("discountLookup", JSON.stringify(data.discounts));
          res(data.discounts);
        }, null, () => {
          rej({});
        });
      } else
        res(JSON.parse(localStorage.getItem("discountLookup")));
    });
  }
}

export async function parkLookupDiscount(force_update = false) {
  return new Promise((res, rej) => {
    if (localStorage.getItem("parkLookupDiscount") !== null && !force_update) {
      res(JSON.parse(localStorage.getItem("parkLookupDiscount")));
    }
    else {
      if (localStorage.getItem("parkLookupDiscount") == null || force_update) {
        authenticatedGetFetchWithoutLoginRedirection("/parks", (response) => {
          localStorage.setItem("parkLookupDiscount", JSON.stringify(response));
          res(response);
        }, null, () => {
          rej({});
        });
      } else {
        res(JSON.parse(localStorage.getItem("parkLookupDiscount")));
      }
    }
  });
}

export async function serverLookupDiscount(force_update = false) {
  if (localStorage.getItem("serverLookup") !== null && !force_update) {
    return JSON.parse(localStorage.getItem("serverLookup"));
  }
  else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("serverLookup") == null || force_update) {
        authenticatedGetFetchWithoutLoginRedirection("/servers", (response) => {
          const sites = parseSite(response);
          localStorage.setItem("serverLookup", JSON.stringify(sites));
          res(sites);
        }, null, () => {
          rej({});
        });
      } else
        res(JSON.parse(localStorage.getItem("serverLookup")));
    });
  }
}


export async function getProfilLookup() {
  if (localStorage.getItem("profilLookup") !== null) {
    return JSON.parse(localStorage.getItem("profilLookup"));
  }
  else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("profilLookup") == null) {
        bonitickAuthenticatedPostFetchWithResult('/bonification/profil', {}, (response, data) => {
          localStorage.setItem("profilLookup", JSON.stringify(data.profils));
          res(data.profils);
        }, null, () => {
          rej({});
        });
      } else
        res(JSON.parse(localStorage.getItem("profilLookup")));
    });
  }
}

export async function getVendorLookup() {
  if (localStorage.getItem("vendorLookup") !== null) {
    return JSON.parse(localStorage.getItem("vendorLookup"));
  }
  else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("vendorLookup") == null) {
        bonitickAuthenticatedPostFetchWithResult('/bonification/vendor', {}, (response, data) => {
          if (response > 300) { res([]); return; }
          if (!data.vendors) data.vendors = [];
          localStorage.setItem("vendorLookup", JSON.stringify(data.vendors));
          res(data.vendors);
        }, null, () => {
          rej([]);
        });
      } else
        res(JSON.parse(localStorage.getItem("vendorLookup")));
    });
  }
}

export async function getCronDateLookup() {
  return new Promise((res, rej) => {
    bonitickAuthenticatedPostFetchWithResult('/bonification/lastCron', {}, (response, data) => {
      if (data.lastCron) {
        const date = new Date(data.lastCron);
        res(date.toLocaleString());
      }
      else {
        res(undefined);
      }
    }, null, () => {
      rej({});
    });
  });

}